module.exports = __webpack_public_path__ + "img/35.c0c16a77.jpg";